import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import packages from './packages'
import { sync } from 'vuex-router-sync'
Vue.use(packages)
Vue.config.productionTip = false
sync(store, router)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  ...App
})



// WEBPACK FOOTER //
// ./src/main.js